import React, { Component } from 'react';
import { connect } from 'react-redux';
import Vitae from '../../common/curriculumVitae';
import SideNav from '../SideNav';
import { saveParams } from '../../../actions/PersonalActions';

class CurriculumVitae extends Component {
    constructor(props) {
        super(props);
        const { userId } = sessionStorage;
        this.props.saveParams({
            userId,
            canEdit: true,
        });
    }

    leave = () => {
        history.go(-1);
    }

    render() {
        return (
            <div className="content">
                <SideNav selectKey='curriculumVitae' />
                <div className="main">
                    <div className="main-content">
                        <Vitae type="personal" />
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params))
    }
}

export default connect(null, mapDispatchToProps)(CurriculumVitae);


// WEBPACK FOOTER //
// ./src/components/personal/curriculumVitae/index.js